import { searchApi } from '@texas/api/endpoints/search/searchApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { ReactSelectOption } from '@texas/types';
import { useCallback, useEffect, useState } from 'react';
import { useDebounce as useDebounceValue } from 'use-debounce';

export function useCustomerSearch() {
  const [input, setInput] = useState('');
  const [debouncedInput] = useDebounceValue(input.trim(), 200);
  const { data, loading, refetch, set } = useApiResource(
    searchApi.searchCustomers,
  );
  const fetchCustomers = useCallback(() => {
    if (debouncedInput.length < 2) {
      set(null);
      return;
    }
    void refetch({ searchTerm: debouncedInput, page: 1, pageSize: 20 });
  }, [debouncedInput, refetch, set]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  return {
    input,
    setInput,
    options: (data?.items ?? []) as ReactSelectOption[],
    loading,
    refresh: fetchCustomers,
  };
}
